import { render, staticRenderFns } from "./ScreenDetailPane.vue?vue&type=template&id=c4a36c98&"
import script from "./ScreenDetailPane.vue?vue&type=script&lang=js&"
export * from "./ScreenDetailPane.vue?vue&type=script&lang=js&"
import style0 from "./ScreenDetailPane.vue?vue&type=style&index=0&id=c4a36c98&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports